'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.init = init;
exports.empty = empty;
var GET_CUMAJOR_DETAIL = 'bp/cumajor/intro/GET_CUMAJOR_DETAIL';
var GET_CUMAJOR_DETAIL_SUCCESS = 'bp/cumajor/intro/GET_CUMAJOR_DETAIL_SUCCESS';
var GET_CUMAJOR_DETAIL_FAIL = 'bp/cumajor/intro/GET_CUMAJOR_DETAIL_FAIL';

var EMPTY_DATA = 'bp/cumajor/intro/EMPTY_DATA';

var initState = {
    detail: {},
    isSearched: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case GET_CUMAJOR_DETAIL:
            return _extends({}, state, {
                detail: {}
            });
        case GET_CUMAJOR_DETAIL_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    isSearched: true
                });
            }
            return _extends({}, state, {
                detail: action.result.data.data,
                isSearched: true
            });
        case EMPTY_DATA:
            return _extends({}, state, {
                detail: {},
                isSearched: false
            });
        default:
            return state;
    }
}

function getCUMajorDetail(majorHashId) {
    return {
        types: [GET_CUMAJOR_DETAIL, GET_CUMAJOR_DETAIL_SUCCESS, GET_CUMAJOR_DETAIL_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/major/detail/' + majorHashId);
            }

            return promise;
        }()
    };
}

function init(majorHashId) {
    return function (dispatch) {
        dispatch(getCUMajorDetail(majorHashId));
    };
}

function empty() {
    return {
        type: EMPTY_DATA
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/cumajor/cumajorIntro.js
// module id = 462
// module chunks = 0